<template>
  <div class="beast-menu-wrap">
    <div class="menu-icon" @click="goMenu"></div>
    <app-menu v-if="config && isShow" :show="isShow" :data="config" @close="close"/>
  </div>
</template>

<script>
import appMenu from './components/main'

import {
  getConfig
} from './apis'

export default {
  components: {
    appMenu
  },

  data () {
    return {
      isShow: false,
      config: null
    }
  },

  methods: {
    getConfig () {
      const cfg = this.getStorage()
      
      if (cfg) {
        this.config = cfg
        this.reqConfig()
      }
      else {
        this.reqConfig(true)
      }
    },

    reqConfig (flag) {
      getConfig()
      .then(data => {
        if (flag) {
          this.config = data.modules
        }
        this.setStorage(data.modules)
      })
    },

    goMenu () {
      this.getConfig()
      this.isShow = !this.isShow
    },

    close () {
      this.isShow = false
    },

    getStorage () {
      let config = window.localStorage.getItem('__beast_config')

      return config ? JSON.parse(config) : null
    },

    setStorage (cfg) {
      window.localStorage.setItem('__beast_config', JSON.stringify(cfg))
    }
  }
}
</script>

<style lang="stylus">
@import "./index.styl"
</style>



// WEBPACK FOOTER //
// index.vue?4a311092